<template>
  <div class="shoppe">
    <div class="query-form">
      <el-form label-position="right" label-width="80px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="买手店">
                  <!-- 保留vendorName -->
                  <el-select v-model="queryForm.vendorId" filterable clearable>
                    <el-option v-for="item in vendorList" :label="item.vendorName" :value="item.vendorId" :key="item.vendorId"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="关联订单">
                  <el-input v-model="queryForm.purchaseOrderNo" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="结算状态">
                  <el-select v-model="queryForm.settlementStatus" clearable>

                    <el-option label="待结算" :value="0"></el-option>
                    <el-option label="待付款" :value="1"></el-option>
                    <el-option label="已结算" :value="2"></el-option>
                    <el-option label="无需结算" :value="-1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="结算单号">
                  <el-input v-model="queryForm.settlementOrderNo" clearable></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
            <el-button @click="search" type="primary">查询</el-button>
            <el-button @click="reset">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <el-button type="primary" @click="showForm">新增</el-button>
    <el-table :data="tableData">
      <el-table-column prop="vendorName" label="买手店"></el-table-column>
      <el-table-column prop="vendorAliasName" label="买手店别名"></el-table-column>
      <el-table-column prop="purchaseOrderNo" label="关联订单号"></el-table-column>
      <el-table-column prop="settlementOrderNo" label="结算单号"></el-table-column>
      <el-table-column prop="amount" label="金额"></el-table-column>
      <el-table-column prop="paymentDescription" label="款项说明"></el-table-column>
      <el-table-column prop="settlementTimestamp" label="结算日期">
        <template slot-scope="scope">
          {{ dateFormat(scope.row.settlementTimestamp) }}
        </template>
      </el-table-column>
      <el-table-column prop="createdTimestamp" label="创建日期">
        <template slot-scope="scope">
          {{ dateFormat(scope.row.createdTimestamp) }}
        </template>
      </el-table-column>
      <el-table-column label="结算状态">
        <template slot-scope="scope">
          <span v-if="scope.row.settlementStatus == -1">无需结算</span>
          <span v-if="scope.row.settlementStatus === 0">待结算</span>
          <span v-if="scope.row.settlementStatus === 1">待付款</span>
          <span v-if="scope.row.settlementStatus === 2">已结算</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100">
        <template slot-scope="scope">
          <el-link type="primary" v-if="scope.row.settlementStatus === 0" @click="removeItem(scope.row)">删除</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="tr"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.pageNo"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="queryForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>

    <el-dialog append-to-body title="新增非订单类结算" :visible.sync="dialogVisible" width="500px">
      <el-form ref="form" :model="form" label-width="100px">
        <el-form-item prop="vendorId" label="买手店" :rules="[{ required: true, message: '请选择买手店' }]">
          <el-select v-model="form.vendorId" filterable>
            <el-option v-for="item in vendorList" :label="item.vendorName" :value="item.vendorId" :key="item.vendorId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item  label="币种">{{ form.vendorId ? vendorUnitMap[form.vendorId] : '' }}</el-form-item>
        <el-form-item prop="purchaseOrderNo" label="关联订单" :rules="[{ required: form.paymentDescription === '履约扣款' || form.paymentDescription === '售前瑕疵确认', message: '请输入关联订单' }]">
          <el-input v-model="form.purchaseOrderNo"></el-input>
        </el-form-item>
        <el-form-item prop="paymentDescription" label="款项说明" :rules="[{ required: true, message: '请选择款项说明' }]">
          <el-select v-model="form.paymentDescription" @change="onChangeDesc" clearable>
            <el-option v-for="item in listDescEnum" :label="item" :value="item" :key="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="form.paymentDescription === 'Remark'" prop="remark" label="备注" :rules="[{ required: true, message: '请输入备注' }]">
          <el-input type="textarea" v-model="form.remark"></el-input>
        </el-form-item>
        <el-form-item prop="amount" label="金额" :rules="[{ required: true, message: '请输入金额' }]">
          <el-input type="number" v-model="form.amount" max="99999999" min="-99999999"></el-input>
        </el-form-item>
        <el-form-item prop="settlementTimestamp" label="结算日期" :rules="[{ required: true, message: '请选择结算日期' }]">
          <el-date-picker
            v-model="form.settlementTimestamp"
            type="date"
            :editable="false"
            :clearable="false"
            value-format="timestamp"
            style="width:100%">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import utils from '@/utils/util';
import {
  getVendorList,
  getNotOrderSettlementList,
  saveNotOrderSettlement,
  delNotOrderSettlement,
  getListDescEnum,
} from "./api";

export default {
  components: {
  },
  data() {
    return {
      vendorList: [],
      vendorUnitMap: {},
      listDescEnum: [],
      queryForm: {
        vendorId: null,
        purchaseOrderNo: null,
        settlementOrderNo: null,
        settlementStatus: null,
        pageNo: 1,
        pageSize: 25,
      },
      tableData: [],
      total: 0,
      dialogVisible: false,
      form: {
        vendorId: null,
        purchaseOrderNo: null,
        settlementOrderNo: null,
        paymentDescription: null,
        remark: '',
        amount: null,
        settlementTimestamp: null,
      },
    };
  },
  mounted() {
    getVendorList().then(res => {
      if (res.data && res.data.data) {
        this.vendorList = res.data.data;
        const map = {};
        res.data.data.forEach(item => {
          map[item.vendorId] = item.originalPriceUnit;
        });
        this.vendorUnitMap = map;
      }
    });
    getListDescEnum().then(res => {
      if (res.data && res.data.data) {
        this.listDescEnum = res.data.data;
      }
    })
    this.getTableData();
  },
  methods: {
    search() {
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    reset() {
      this.queryForm.vendorId = null;
      this.queryForm.purchaseOrderNo = null;
      this.queryForm.settlementOrderNo = null;
      this.queryForm.settlementStatus = null;
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    getTableData() {
      getNotOrderSettlementList(this.queryForm).then(res => {
        if (res.data && res.data.data) {
          this.total = res.data.data.total;
          this.tableData = res.data.data.list;
        }
      })
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(pageNo) {
      this.queryForm.pageNo = pageNo;
      this.getTableData();
    },
    dateFormat(time) {
      if (!time) {
        return '';
      }
      return utils.dateFormat(new Date(time), 'yyyy-MM-dd hh:mm:ss');
    },
    onChangeDesc(val) {
      if (val !== '备注') {
        this.form.remark = '';
      }
    },
    showForm() {
      this.form.vendorId = null;
      this.form.purchaseOrderNo = null;
      this.form.paymentDescription = null;
      this.form.remark = null;
      this.form.amount = null;
      this.form.settlementTimestamp = Date.now();
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      })
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!this.repeatSave) {
            this.repeatSave = true;
            saveNotOrderSettlement({
              ...this.form,
              paymentDescription: this.form.paymentDescription === 'Remark' ? `Remark-${this.form.remark}` : this.form.paymentDescription,
            }).then(res => {
              this.repeatSave = false;
              if (res.data.success) {
                this.$message.success('提交成功');
                this.dialogVisible = false;
                this.getTableData();
              } else {
                this.$message.error(res.data.data || res.data.message);
              }
            }).catch(() => {
              this.repeatSave = false;
            })
          }
        } else {
          this.$message.error('请完善信息');
          return false;
        }
      });
    },
    removeItem(row) {
      this.$confirm(`确认删除吗?`, '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delNotOrderSettlement({
          nonOrderSettlementId: row.nonOrderSettlementId
        }).then((res) => {
          if (res.data.success) {
            this.$message.success(res.data.message || '操作成功');
            this.getTableData();
          } else {
            this.$message.error(res.data.message || '系统异常，请稍后再试');
          }
        })
      }).catch(() => {});
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.ml10 {
  margin-left: 10px;
}
.store-wrap {
  max-height: 500px;
  overflow: auto;
}
.store-list {
  display: flex;
  margin-bottom: 2px;
  border: 1px solid #DCDFE6;
  border-radius: 5px;

  .store-name {
    flex: 0 0 auto;
    width: 150px;
    padding: 10px;
    border-right: 1px solid #DCDFE6;
  }
  .store-stocklocation-list {
    padding: 10px;
  }
}
.sl-group {
  display: flex;
  flex-wrap: wrap;

  .sl-item {
    margin-right: 10px;
    margin-top: 10px;
    padding: 0 5px;
    line-height: 30px;
    border: 1px solid #DCDFE6;
    border-radius: 4px;
  }
  .icon-close:hover {
    color: #409EFF;
  }
}
.vendor-name {
  white-space:nowrap;
  text-overflow:ellipsis;
  overflow:hidden;
}
</style>
